// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__20sAo","approved":"Status_approved__iMcvZ","rejected":"Status_rejected__2s7u8","expired":"Status_expired__2xtIN","label":"Status_label__1_1C2"};